<template>
    <FormControl
        required
        label="Time before the meeting starts"
    >
        <div class="flex items-center gap-1">
            <TextInput
                type="number"
                inputmode="numeric"
                :min="
                    dummyTimeAmountType === TimeAmountTypeEnum.Minutes ? 30 : 1
                "
                :step="
                    dummyTimeAmountType === TimeAmountTypeEnum.Minutes ? 30 : 1
                "
                :name="`${RequestBodyKeyEnum.App_Automation_Update_TriggerData_TimeAmount}[${TIMEAMOUNT_AMOUNT_FIELD_KEY}]`"
                :value="triggerData.data.timeAmount.amount"
                required
            />
            <SelectInput
                :name="`${RequestBodyKeyEnum.App_Automation_Update_TriggerData_TimeAmount}[${TIMEAMOUNT_TYPE_FIELD_KEY}]`"
                v-model="dummyTimeAmountType"
                required
            >
                <option :value="TimeAmountTypeEnum.Minutes">Minutes</option>
                <option :value="TimeAmountTypeEnum.Hours">Hours</option>
                <option :value="TimeAmountTypeEnum.Days">Days</option>
            </SelectInput>
        </div>
    </FormControl>

    <FormControl
        label="Services"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Automation_Update_TriggerData_ServiceIds,
            )
        "
        required
    >
        <ServiceCheckboxTable
            :services="services"
            :requestInputName="`${RequestBodyKeyEnum.App_Automation_Update_TriggerData_ServiceIds}[]`"
            :isServiceSelectedCallback="
                (serviceId: ServiceID) =>
                    triggerData.data.serviceIds.includes(`${serviceId.value}`)
            "
            :disabled="dummyTriggerForAllServices"
        />
    </FormControl>

    <FormControl
        label="Watch all services"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Automation_Update_TriggerData_ServiceIds,
            )
        "
        required
    >
        <ToggleInput
            label="Trigger this automation for all current and future services"
            :checked="dummyTriggerForAllServices"
            :name="
                RequestBodyKeyEnum.App_Automation_Update_TriggerData_TriggerForAllServices
            "
            v-model="dummyTriggerForAllServices"
        />
    </FormControl>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import ToggleInput from '@/Shared/Component/Forms/ToggleInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import {
        TIMEAMOUNT_AMOUNT_FIELD_KEY,
        TIMEAMOUNT_TYPE_FIELD_KEY,
        TimeAmountTypeEnum,
        type AutomationTriggerDataXMinutesBeforeMeetingStartsType,
    } from '@/Shared/AutoGenerated/Main'
    import ServiceCheckboxTable from '@/App/Service/Component/Service/ServiceCheckboxTable.vue'
    import Service from '@/App/Service/Entity/Service'
    import ServiceID from '@/App/Service/Entity/ServiceID'

    const props = defineProps({
        triggerData: {
            type: Object as PropType<AutomationTriggerDataXMinutesBeforeMeetingStartsType>,
            required: true,
        },
        services: {
            type: Object as PropType<Service[]>,
            required: true,
        },
        errors: {
            type: [Object, null] as PropType<ApiFormErrors | null>,
            required: true,
        },
    })

    const dummyTriggerForAllServices = ref<boolean>(
        props.triggerData.data.triggerForAllServices,
    )
    const dummyTimeAmountType = ref<TimeAmountTypeEnum>(
        props.triggerData.data.timeAmount.type,
    )
</script>
